// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/GetToken/GetToken.css
// module id = 1995
// module chunks = 0